import React from "react";
import { Button, Table } from "semantic-ui-react";

export class TableSearchFilter extends React.Component {
  state = {
    input: undefined,
  };
  clearSearch = () => {
    this.state.input.value = "";
    this.props.onSearch("");
  };
  render() {
    return (
      <Table className="table-no-border-and-padding">
        <Table.Body>
          <Table.Row>
            <Table.Cell width={1}>Search:</Table.Cell>
            <Table.Cell width={6}>
              <input
                className="form-control"
                ref={(n) => {
                  this.state.input = n;
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    this.props.onSearch("");
                  }
                }}
                onChange={() => {
                  this.props.onSearch(this.state.input.value);
                }}
                type="text"
              />
            </Table.Cell>
            <Table.Cell width={1}>
              <Button onClick={this.clearSearch} value="Clear">
                Clear
              </Button>
            </Table.Cell>
            <Table.Cell width={8} />
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default TableSearchFilter;



// WEBPACK FOOTER //
// ./src/components/common/TableSearchFilter.js